import { Button } from '@mui/material'
import { useTranslation } from 'react-i18next'

import DangerIcon from '../../assets/icons/danger-icon.svg'
import { baseButtonBlueBg } from '../../theme/custom-styles'
import WarningIcon from '../../assets/icons/warning-icon.svg'

export const PaymentToReviewTableRow = ({
  icon,
  subtitle,
  infoData,
  isDangerInfo,
  dangerInfoData,
  warningInfoData,
  displayDangerIcon,
  displayWarningIcon,
  hideReviewButtonInRow,
  backgroundResearchData,
  displayBackgroundResearchData,
  handleOpenDialogToResolveNovelty
}: {
  icon: string
  subtitle: string
  infoData: string
  isDangerInfo: boolean
  dangerInfoData?: string
  warningInfoData?: string
  displayDangerIcon: boolean
  displayWarningIcon: boolean
  hideReviewButtonInRow?: boolean
  displayBackgroundResearchData: boolean
  handleOpenDialogToResolveNovelty: () => void
  backgroundResearchData: { riskLevel: number }
}) => {
  const { t } = useTranslation(['payments-to-review-management'])

  const handleGetBackgroundResearchResult = (backgroundResearchData: { riskLevel: number }) => {
    return (
      <div className="background-research-data-container">
        <div className="background-research-risk-data-container">
          <div className="background-research-bar-container">
            <div
              className="background-research-bar-fill"
              style={{
                width: `${backgroundResearchData.riskLevel >= 1 && backgroundResearchData.riskLevel <= 4 ? 100 : backgroundResearchData.riskLevel >= 5 && backgroundResearchData.riskLevel <= 6 ? 50 : 0}%`,
                backgroundColor:
                  backgroundResearchData.riskLevel >= 1 && backgroundResearchData.riskLevel <= 4 ? '#EF4444' : backgroundResearchData.riskLevel >= 5 && backgroundResearchData.riskLevel <= 6 ? '#F59E0B' : '#22C55E'
              }}
            ></div>
          </div>
          <div className="background-research-risk-text">{`${t('noveltiesTable.riskLevel')}: ${
            backgroundResearchData.riskLevel >= 1 && backgroundResearchData.riskLevel <= 4
              ? t('noveltiesTable.high')
              : backgroundResearchData.riskLevel >= 5 && backgroundResearchData.riskLevel <= 6
              ? t('noveltiesTable.medium')
              : t('noveltiesTable.low')
          }`}</div>
        </div>
      </div>
    )
  }

  const handleGetDangerInfoData = (dangerInfoData: string) => {
    return (
      <div className="info-data-container">
        <div className="icon-container">
          <img
            src={DangerIcon}
            alt="danger-icon"
          />
        </div>
        <div className="info-data-text">{dangerInfoData}</div>
      </div>
    )
  }

  const handleGetWarningInfoData = (warningInfoData: string) => {
    return (
      <div className="info-data-container">
        <div className="icon-container">
          <img
            src={WarningIcon}
            alt="warning-icon"
          />
        </div>
        <div
          className="info-data-text"
          style={{ color: '#F59E0B' }}
        >
          {warningInfoData}
        </div>
      </div>
    )
  }

  return (
    <div className="table-row-container">
      <div className="left-content">
        <div className="icon-container">
          <img
            src={icon}
            alt="table-row-icon"
          />
        </div>
        <div className="table-row-content-subtitle">{subtitle}</div>
      </div>
      <div className="right-content">
        <div className={isDangerInfo ? 'table-row-info-data payment-to-review-details-danger-text' : 'table-row-info-data'}>
          {displayDangerIcon && handleGetDangerInfoData(String(dangerInfoData))}
          {displayWarningIcon && handleGetWarningInfoData(String(warningInfoData))}
          {displayBackgroundResearchData ? handleGetBackgroundResearchResult(backgroundResearchData) : <div className="info-data-general-text">{infoData}</div>}
        </div>
        {isDangerInfo && !hideReviewButtonInRow && (
          <div className="payment-to-review-review-button-container">
            <Button
              variant="text"
              sx={baseButtonBlueBg}
              onClick={handleOpenDialogToResolveNovelty}
            >
              {t('noveltiesTable.reviewButtonText')}
            </Button>
          </div>
        )}
      </div>
    </div>
  )
}
